module.exports = __webpack_public_path__ + "img/chengdu_door.155bb415.jpg";